import { FlexBox, marginEdgesRules } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import React from 'react'
import { CompProps } from 'types'

/**
 * @note
 * A container that can be used for other elements on the page
 * outside of the main sticky/column layout.
 */
export const ClubDetailContainer = ({
  children,
  className,
  ...props
}: CompProps<React.HTMLAttributes<HTMLDivElement>>) => {
  const { mediaQueries } = useTheme()

  return (
    <FlexBox
      className={cx(
        css`
          overflow: hidden;
          padding: 0 ${marginEdgesRules.mobile};
          ${mediaQueries.mobileL} {
            padding: 0 ${marginEdgesRules.tablet};
          }
        `,
        className
      )}
      width="100%"
      justifyContent="center"
      {...props}
    >
      <div
        className={css`
          max-width: 352px;
          width: 100%;
          ${mediaQueries.tabletL} {
            max-width: 1044px;
          }
        `}
      >
        {children}
      </div>
    </FlexBox>
  )
}
